<div ngbDropdown class="Sanofi-OrderHistoryStatusesDropdown">
  <button type="button" class="Sanofi-OrderHistoryStatusesDropdown__mainButton w-100 text-left px-3" id="statusesDropdown" ngbDropdownToggle>
    {{'ordersList.selectStatusPlaceholder' | cxTranslate}}
    <fa-icon class="Sanofi-OrderHistoryStatusesDropdown__chevronIcon" [icon]="faChevronDown"></fa-icon>
  </button>
  <div ngbDropdownMenu aria-labelledby="statusesDropdown">
    <div class="px-2 py-2" [formGroup]="statusesForm">
      @for (status of statuses; track status) {
        <div class="my-2 Sanofi-OrderHistoryStatusesDropdown__selectCheckBox">
          <input type="checkbox" class="form-control" id="{{status}}" [formControlName]="status"/>
          <label class="py-2 mb-0" for="{{status}}">{{ ('ordersList.statuses.' + status) | cxTranslate }}</label>
        </div>
      }
    </div>
  </div>
</div>
